// extracted by mini-css-extract-plugin
module.exports = {"titleGroup":"NetworksList-module--titleGroup--ofL3q","networks":"NetworksList-module--networks--1gqjd Box-module--box--X0EGm"};